var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0099DF"
    },
    d: "M512,402.282c0,16.716-13.55,30.267-30.265,30.267H30.265C13.55,432.549,0,418.996,0,402.282V109.717 c0-16.715,13.55-30.266,30.265-30.266h451.469c16.716,0,30.265,13.551,30.265,30.266L512,402.282L512,402.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#202121",
      enableBackground: "new"
    },
    d: "M21.517,402.282V109.717 c0-16.715,13.552-30.266,30.267-30.266h-21.52C13.55,79.451,0,93.003,0,109.717v292.565c0,16.716,13.55,30.267,30.265,30.267h21.52 C35.07,432.549,21.517,418.996,21.517,402.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA001B"
    },
    d: "M334.687,234.577c0-18.028,8.304-34.115,21.296-44.649c-9.872-8.005-22.455-12.806-36.156-12.806 c-31.731,0-57.45,25.722-57.45,57.454c0,31.731,25.719,57.451,57.45,57.451c13.703,0,26.284-4.798,36.156-12.806 C342.991,268.69,334.687,252.604,334.687,234.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F79F1A"
    },
    d: "M392.14,177.123c-13.703,0-26.28,4.801-36.156,12.806c12.994,10.534,21.298,26.621,21.298,44.649 c0,18.027-8.304,34.113-21.298,44.645c9.876,8.007,22.455,12.806,36.156,12.806c31.733,0,57.452-25.72,57.452-57.451 C449.592,202.845,423.871,177.123,392.14,177.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5F01"
    },
    d: "M377.281,234.577c0-18.028-8.304-34.115-21.298-44.649c-12.991,10.534-21.296,26.621-21.296,44.649 c0,18.027,8.304,34.113,21.296,44.645C368.976,268.69,377.281,252.604,377.281,234.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC715"
    },
    d: "M165.843,261.211c0,4.037-3.276,7.308-7.308,7.308H67.852c-4.037,0-7.308-3.271-7.308-7.308v-70.667 c0-4.037,3.272-7.307,7.308-7.307h90.683c4.033,0,7.308,3.27,7.308,7.307V261.211L165.843,261.211z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34495E"
    },
    d: "M166.843,331.106h-106.3c-4.611,0-8.348-3.738-8.348-8.348c0-4.611,3.736-8.348,8.348-8.348h106.3 c4.611,0,8.348,3.736,8.348,8.348C175.191,327.368,171.454,331.106,166.843,331.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34495E"
    },
    d: "M166.843,365.919h-106.3c-4.611,0-8.348-3.736-8.348-8.348c0-4.611,3.736-8.348,8.348-8.348h106.3 c4.611,0,8.348,3.736,8.348,8.348C175.191,362.182,171.454,365.919,166.843,365.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFA617"
    },
    points: "88.893,268.52 105.589,268.52 105.589,260.172 105.589,191.584 105.589,183.236  88.893,183.236 88.893,191.584 88.893,203.314 68.891,203.314 60.543,203.314 60.543,220.01 68.891,220.01 88.893,220.01  88.893,231.746 68.891,231.746 60.543,231.746 60.543,248.441 68.891,248.441 88.893,248.441 88.893,260.172  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA617"
    },
    d: "M157.496,220.01h8.348v-16.696h-8.348h-15.92v-11.73v-8.348H124.88v8.348v48.509 c0,4.61,3.736,8.348,8.348,8.348h24.268h8.348v-16.696h-8.348h-15.92V220.01H157.496z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#202121",
      enableBackground: "new"
    },
    d: "M75.92,261.211v-70.667c0-4.037,3.271-7.307,7.308-7.307 H67.852c-4.037,0-7.308,3.27-7.308,7.307v70.667c0,4.037,3.272,7.308,7.308,7.308h15.377C79.191,268.52,75.92,265.248,75.92,261.211 z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.1fa88d7ab45484827ca21b311457c05b.svg";
export { ForwardRef as ReactComponent };